import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Upcoming } from '@app/interfaces/upcoming';
import { UpcomingUtils } from '@app/utils/upcomingUtils';
@Component({
  selector: 'app-upcoming-details',
  templateUrl: './upcoming-details.page.html',
  styleUrls: ['./upcoming-details.page.scss'],
})
export class UpcomingDetailsPageComponent implements OnInit {

  @Input() upcoming: Upcoming;

  constructor(private modalController: ModalController, private upcomingUtils: UpcomingUtils) {}

  ngOnInit() {
    if (Array.isArray(this.upcoming)) {
      const upcomings = this.upcomingUtils.upcomingList(this.upcoming, 'notification');
      const upcomingChange = upcomings.find(upcoming => upcoming.change);
      // if upcoming change is accommodation select from work because assumed user already on site so upcoming to work
      // travel from work will be negative
      this.upcoming = upcomingChange ? upcomingChange : upcomings[1];
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
